import {
    optionTitle_connected,
    optionSearch_connected,
} from './ConnectedAccountsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ConnectedAccountsOption: LazyOption = createLazyOption(
    {
        key: 'connected',
        titleStringKey: optionTitle_connected,
        searchTermsStringKey: optionSearch_connected,
        isHidden: isOptionHidden,
        allowedOptionKeys: ['AttachmentConnectedAccounts', 'ConnectedAccounts'],
    },
    lazyFullModule,
    m => m.default
);

function isOptionHidden(): boolean {
    return IsShadowMailboxUser() || !isConsumer();
}

export default ConnectedAccountsOption;
